/* --- v6 (23/09): menu card rotation. One of the pool shows per page view; the first without JS. --- */
(function(){
  document.querySelectorAll('[data-rotate]').forEach(function(g){
    var cards = Array.prototype.slice.call(g.children); if (cards.length < 2) return;
    var i = Math.floor(Math.random() * cards.length);
    cards.forEach(function(c, k){ c.hidden = (k !== i); });
  });
})();

/* --- v6: the commission brief also lands in our own system (project enquiry + hand-off e-mail).
   Shopify's own contact mail keeps working; this is fire-and-forget and never blocks the form. --- */
(function(){
  var f = document.getElementById('CommissionForm'); if (!f) return;
  var url = f.getAttribute('data-brief-url'); if (!url) return;
  f.addEventListener('submit', function(){
    try {
      var d = {}; new FormData(f).forEach(function(v, k){ var m = /^contact\[(.+)\]$/.exec(k); if (m) d[m[1]] = String(v).slice(0, 2000); });
      d.page = location.href; d.source = 'website-brief';
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ply_brief_submitted', { what: d.What || '', budget: d.Budget || '', page: location.pathname }); } catch (x) {}
      var body = JSON.stringify(d);
      if (navigator.sendBeacon) { navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); }
      else { fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function(){}); }
    } catch (e) {}
  });
})();

/* --- v6 (24/09): lead signals for ad tracking. Published as Shopify customer events, so a custom
   pixel (Settings → Customer events) can forward them to Meta as Lead / Contact and to Google Ads as
   conversions, without any ad script in the theme. Nothing is sent anywhere until that pixel exists. --- */
(function(){
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (!a) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ply_whatsapp_click', { page: location.pathname, label: (a.textContent || '').trim().slice(0, 60) }); } catch (x) {}
  }, true);
})();

/* --- 7 Oct (v5.1): the header's announcement bar scrolls away above the sticky header (see v6.css).
   Measure the bar so the sticky offset is exact; re-measure when fonts settle or the window resizes. --- */
(function(){
  if (document.body.classList.contains('template-index')) return;
  var c = document.querySelector('[data-chrome]'); if (!c) return;
  var h = c.querySelector('.header'); if (!h) return;
  function set(){ var d = Math.round(h.getBoundingClientRect().top - c.getBoundingClientRect().top); c.style.setProperty('--ann-h', Math.max(0, d) + 'px'); }
  set();
  window.addEventListener('resize', set, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
})();
